import { observable, action,  } from 'mobx'
import * as services from 'services/graphic'
import { isDataExist } from 'utils/dataTools'
import { message } from 'antd'


class Graphic {
  @observable picList = []
  @observable picPage = {pageIndex:1,pageSize:10}
  @observable picLoading = false
  @observable materialList = []
  @observable deviceList = []
  @observable procedureList = []
  @observable fileList = []
  @observable formData = {}
  @observable selectData = []; //第一级关联
  @observable secondSelectData = []; //第二级关联

  @action async getFile(params){
    try {
      let res = await services.getRequest(services.requestUrl.getFile,params)
      if(isDataExist(res)){
        this.materialList = res.data.data
      }
    } catch (error) {
      console.log(error);
      
    }
  }
  // 获取表格数据
  @action async getData(params){
    this.picLoading = true
    try {
      let res = await services.getRequest(services.requestUrl.getPic,params)
      this.picLoading = false
      if(isDataExist(res)){
        this.picList = res.data.data.items
        this.picPage = res.data.data.page
      }
    } catch (error) {
      
    }
  }
  // 获取设备-下拉框
  @action async getDevice(params){
    try {
      let res = await services.getRequest(services.requestUrl.getDevice,params)
      if(isDataExist(res)){
        this.selectData = res.data.data
      }
    } catch (error) {
      console.log(error)
    }
  }
  // 获取工序-下拉框
  @action async getProcedure(type,params){
    try {
      let res = await services.getRequest(services.requestUrl.getProcedure,params)
      if(isDataExist(res)){
        if(type == 1){
          this.selectData = res.data.data
        }
        else if(type == 2){
          this.secondSelectData = res.data.data
        }
      }
    } catch (error) {
      console.log(error)
    }
  }
  // 获取物料-下拉框
  @action async getMaterial(type,params){
    try {
      let res = await services.getRequest(services.requestUrl.getMaterial,params)
      if(isDataExist(res)){
        if(type == 1){
          this.selectData = res.data.data
        }
        else if(type == 2){
          this.secondSelectData = res.data.data
        }
      }
    } catch (error) {
      console.log(error)
    }
  }
  // 获取工具-下拉框
  @action async getTool(params){
    try {
      let res = await services.getRequest(services.requestUrl.getTool,params)
      if(isDataExist(res)){
        this.selectData = res.data.data
      }
    } catch (error) {
      console.log(error)
    }
  }
  // 删除
  @action async delete(params){
    try {
      let res = await services.putRequest(services.requestUrl.delete,params)
      if(isDataExist(res)){
        message.success('删除成功！')
        this.getData({businessType:params.typeId,...this.picPage})
      }
    } catch (error) {
      console.log(error)
    }
  }
  // 添加/修改
  @action async save(params){
    try{
      let res=await services.putRequest(services.requestUrl.save,params)
      if(isDataExist(res)){
        return res.data
      }
    } catch (error){
      console.log(error)
    }
  }
}
let GraphicStore = new Graphic()
export default GraphicStore
